// extracted by mini-css-extract-plugin
export default {"frame":"NestableFrame_frame__aOK++","frameDepthEven":"NestableFrame_frameDepthEven__U8sGG","frameDepthOdd":"NestableFrame_frameDepthOdd__EtBnq"};